import { Card, CardContent } from "@/components/ui/card";
import { Quote } from "lucide-react";

const testimonials = [
  {
    name: "Rodrigo Figueroa",
    role: "Director de Proyecto",
    comment: "Excelente servicio y profesionalismo en cada etapa del proyecto. Superaron nuestras expectativas."
  },
  {
    name: "Rodrigo Jiménez",
    role: "Gerente de Operaciones",
    comment: "La calidad del trabajo y el cumplimiento de plazos fue impecable. Altamente recomendados."
  },
  {
    name: "Javier Román Palma",
    role: "Ingeniero Jefe",
    comment: "Un equipo comprometido con la excelencia y la seguridad. Grandes profesionales."
  },
  {
    name: "Manuel Vélez Samaniego",
    role: "Coordinador Técnico",
    comment: "Soluciones innovadoras y atención personalizada. Una empresa en la que se puede confiar."
  }
];

const Testimonials = () => {
  return (
    <section className="py-24 bg-background relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-20 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-montserrat font-bold mb-6 text-balance">
            TESTIMONIOS
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-inter leading-relaxed">
            Lo que dicen nuestros clientes sobre nosotros
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <Card 
              key={index}
              className="glass-liquid-medium hover-liquid border-border-glass-medium group cursor-pointer relative overflow-hidden shadow-liquid-lg"
            >
              {/* Shimmer Effect */}
              <div className="absolute inset-0 glass-shimmer opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              
              <CardContent className="p-8 relative z-10">
                <Quote className="w-12 h-12 text-primary/20 mb-4" />
                <p className="text-muted-foreground font-inter leading-relaxed mb-6 text-justify hyphens-auto">
                  "{testimonial.comment}"
                </p>
                <div>
                  <p className="font-montserrat font-bold text-foreground">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-muted-foreground font-inter">
                    {testimonial.role}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Featured Quote */}
        <Card className="max-w-4xl mx-auto glass-liquid-medium border-border-glass-medium bg-gradient-to-br from-primary/10 to-primary/5 shadow-liquid-xl rounded-3xl">
          <CardContent className="p-12 text-center">
            <Quote className="w-16 h-16 text-primary/40 mx-auto mb-6" />
            <blockquote className="text-xl md:text-2xl font-inter leading-relaxed text-foreground mb-6 text-justify hyphens-auto">
              "La eficiencia energética no es solo una cuestión de tecnología, es una filosofía que debe guiar cada decisión en nuestros proyectos."
            </blockquote>
            <p className="text-lg font-montserrat font-bold text-primary">
              José Goldemberg
            </p>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default Testimonials;
